import { SlideOverContentWrapper } from '@/components/slideOvers_v2';
import { Audience } from '@/models/audiences';
import { FC, PropsWithChildren } from 'react';
import { useWorkspace } from '@/features/workspaces/hooks';
import { useGetDataSourcesByIdsQuery } from '@/services/dataSources';
import { SpinnerIcon } from '@/components/icons';
import { UsedDataSourceSection, UsedRulesSection } from './components';
import { useGetPropertyOperationsQuery } from '@/services/endpoints/audiences';

type AudienceDetailSlideOverContentProps = PropsWithChildren<{
  audience: Audience;
}>;

export const AudienceDetailSlideOverContent: FC<AudienceDetailSlideOverContentProps> = ({ audience }) => {
  const workspace = useWorkspace();

  const { isLoading, data } = useGetDataSourcesByIdsQuery({
    workspaceId: workspace.id,
    datasourceIds: audience?.datasourceIds || [],
  });

  const { data: { propertyOperations } = {} } = useGetPropertyOperationsQuery({
    workspaceId: workspace.id,
    audienceId: audience.id,
  });

  const dataSources = data || [];

  return (
    <SlideOverContentWrapper>
      {isLoading ? (
        <div className='flex grow items-center justify-center'>
          <SpinnerIcon className='size-10' loading />
        </div>
      ) : (
        <>
          <UsedRulesSection audience={audience} propertyOperations={propertyOperations} />
          <UsedDataSourceSection datasources={dataSources} />
        </>
      )}
    </SlideOverContentWrapper>
  );
};
